module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.GridColumn = exports.Grid = void 0;
    var _Grid = __webpack_require__(2);
    Object.defineProperty(exports, "Grid", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Grid).default;
        }
    });
    var _GridColumn = __webpack_require__(14);
    Object.defineProperty(exports, "GridColumn", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_GridColumn).default;
        }
    });
    var _Page = __webpack_require__(16), _Page2 = _interopRequireDefault(_Page);
    exports.default = _Page2.default;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _class, _temp2, _keys = __webpack_require__(3), _keys2 = _interopRequireDefault(_keys), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(10), _vars = __webpack_require__(11), _GridElement = __webpack_require__(12), _GridElement2 = _interopRequireDefault(_GridElement);
    exports.default = (0, _styledComponents.withTheme)((_temp2 = _class = function(_PureComponent) {
        function AkGrid() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, AkGrid);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AkGrid.__proto__ || (0, 
            _getPrototypeOf2.default)(AkGrid)).call.apply(_ref, [ this ].concat(args))), _this.getTheme = function(props) {
                return {
                    columns: props.theme && props.theme.columns ? props.theme.columns : _vars.defaultGridColumns,
                    spacing: props.theme && props.theme.spacing ? props.theme.spacing : props.spacing,
                    isNestedGrid: !(!props.theme || !props.theme.isNestedGrid) && props.theme.isNestedGrid
                };
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(AkGrid, _PureComponent), (0, _createClass3.default)(AkGrid, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement(_styledComponents.ThemeProvider, {
                    theme: this.getTheme(this.props)
                }, _react2.default.createElement(_GridElement2.default, {
                    spacing: this.props.spacing,
                    layout: this.props.layout
                }, this.props.children));
            }
        } ]), AkGrid;
    }(_react.PureComponent), _class.propTypes = {
        children: _react.PropTypes.node,
        spacing: _react.PropTypes.oneOf((0, _keys2.default)(_vars.spacing)),
        layout: _react.PropTypes.oneOf(_vars.layout)
    }, _class.defaultProps = {
        spacing: "cosy",
        layout: "fixed"
    }, _temp2));
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/keys");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 11 */
/***/
function(module, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var defaultGridSize = exports.defaultGridSize = 8;
    exports.defaultGridColumns = 12, exports.defaultGridColumnWidth = 10 * defaultGridSize, 
    exports.spacing = {
        comfortable: 5 * defaultGridSize,
        cosy: 2 * defaultGridSize,
        compact: .5 * defaultGridSize
    }, exports.layout = [ "fixed", "fluid" ];
}, /* 12 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.getPadding = exports.getMaxWidth = exports.getMargin = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(13), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 ", ";\n  max-width: ", ";\n  padding: 0 ", ";\n  position: relative;\n" ], [ "\n  align-items: flex-start;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 ", ";\n  max-width: ", ";\n  padding: 0 ", ";\n  position: relative;\n" ]), _styledComponents = __webpack_require__(10), _styledComponents2 = _interopRequireDefault(_styledComponents), _vars = __webpack_require__(11), getMargin = function(props) {
        return props.theme.isNestedGrid ? "-" + _vars.spacing[props.theme.spacing] + "px" : "auto";
    }, getMaxWidth = function(props) {
        return "fixed" === props.layout ? _vars.defaultGridColumnWidth * props.theme.columns + "px" : "100%";
    }, getPadding = function(props) {
        return _vars.spacing[props.theme.spacing] / 2 + "px";
    }, Grid = _styledComponents2.default.div(_templateObject, getMargin, getMaxWidth, getPadding);
    exports.default = Grid, exports.getMargin = getMargin, exports.getMaxWidth = getMaxWidth, 
    exports.getPadding = getPadding;
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 14 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _class, _temp2, _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(10), _vars = __webpack_require__(11), _GridColumnElement = __webpack_require__(15), _GridColumnElement2 = _interopRequireDefault(_GridColumnElement), defaultSpacing = "cosy";
    exports.default = (0, _styledComponents.withTheme)((_temp2 = _class = function(_PureComponent) {
        function AkGridColumn() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, AkGridColumn);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = AkGridColumn.__proto__ || (0, 
            _getPrototypeOf2.default)(AkGridColumn)).call.apply(_ref, [ this ].concat(args))), 
            _this.getTheme = function(props) {
                return {
                    columns: props.theme && props.theme.columns ? props.theme.columns : _vars.defaultColumns,
                    spacing: props.theme && props.theme.spacing ? props.theme.spacing : defaultSpacing,
                    isNestedGrid: !1
                };
            }, _this.getNestedTheme = function(props) {
                return {
                    columns: props.medium,
                    spacing: props.theme && props.theme.spacing ? props.theme.spacing : defaultSpacing,
                    isNestedGrid: !0
                };
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(AkGridColumn, _PureComponent), (0, _createClass3.default)(AkGridColumn, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement(_styledComponents.ThemeProvider, {
                    theme: this.getTheme(this.props)
                }, _react2.default.createElement(_GridColumnElement2.default, {
                    medium: this.props.medium
                }, _react2.default.createElement(_styledComponents.ThemeProvider, {
                    theme: this.getNestedTheme(this.props)
                }, _react2.default.createElement("div", null, this.props.children))));
            }
        } ]), AkGridColumn;
    }(_react.PureComponent), _class.propTypes = {
        medium: _react.PropTypes.number,
        children: _react.PropTypes.node
    }, _class.defaultProps = {
        medium: 0
    }, _temp2));
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.getColumnWidth = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(13), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: ", ";\n  margin: 0 ", "px;\n  max-width: calc(", " - ", "px);\n  min-width: calc(99.9999% / ", " - ", "px);\n  word-wrap: break-word;\n" ], [ "\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: ", ";\n  margin: 0 ", "px;\n  max-width: calc(", " - ", "px);\n  min-width: calc(99.9999% / ", " - ", "px);\n  word-wrap: break-word;\n" ]), _styledComponents = __webpack_require__(10), _styledComponents2 = _interopRequireDefault(_styledComponents), _vars = __webpack_require__(11), getColumnRatio = function(props) {
        return props.medium === props.theme.columns ? "100%" : "99.9999% / " + props.theme.columns + " * " + props.medium;
    }, getColumnWidth = function(props) {
        return props.medium > 0 ? "calc(" + getColumnRatio(props) + " - " + _vars.spacing[props.theme.spacing] + "px)" : "auto";
    }, availableColumns = function(props) {
        return props.theme.columns;
    }, specifiedColumns = function(props) {
        return props.medium ? props.medium : availableColumns(props);
    }, columns = function(props) {
        return Math.min(availableColumns(props), specifiedColumns(props));
    }, gridSpacing = function(props) {
        return _vars.spacing[props.theme.spacing];
    }, getMaxWidthColumnRatio = function(props) {
        return columns(props) >= availableColumns(props) ? "100%" : "99.9999% / " + availableColumns(props) + " * " + columns(props);
    }, GridColumn = _styledComponents2.default.div(_templateObject, getColumnWidth, function(props) {
        return _vars.spacing[props.theme.spacing] / 2;
    }, getMaxWidthColumnRatio, gridSpacing, availableColumns, gridSpacing);
    exports.default = GridColumn, exports.getColumnWidth = getColumnWidth;
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _taggedTemplateLiteral2 = __webpack_require__(13), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 100%;\n" ], [ "\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  width: 100%;\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n" ], [ "\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: auto;\n  transition: height .25s ease-in-out;\n  height: ", "px; /* 52 is line height (20) + 4*grid */\n  position: relative;\n  width: 100%;\n  z-index: 3;\n" ], [ "\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: auto;\n  transition: height .25s ease-in-out;\n  height: ", "px; /* 52 is line height (20) + 4*grid */\n  position: relative;\n  width: 100%;\n  z-index: 3;\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  position: fixed;\n  width: 100%;\n" ], [ "\n  position: fixed;\n  width: 100%;\n" ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: auto;\n  position: relative;\n  max-height: 100%;\n  z-index: 2;\n" ], [ "\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: auto;\n  position: relative;\n  max-height: 100%;\n  z-index: 2;\n" ]), _templateObject6 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: auto;\n  position: relative;\n  z-index: 1;\n  width: calc(100% - ", "px);\n" ], [ "\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: auto;\n  position: relative;\n  z-index: 1;\n  width: calc(100% - ", "px);\n" ]), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _styledComponents = __webpack_require__(10), _styledComponents2 = _interopRequireDefault(_styledComponents), Wrapper = _styledComponents2.default.div(_templateObject), NavigationAndContent = _styledComponents2.default.div(_templateObject2), BannerContainer = _styledComponents2.default.div(_templateObject3, function(props) {
        return props.isBannerOpen ? 52 : 0;
    }), Banner = _styledComponents2.default.div(_templateObject4), Navigation = _styledComponents2.default.div(_templateObject5), PageContent = _styledComponents2.default.div(_templateObject6, function(props) {
        return props.navigationWidth;
    }), Page = function(_PureComponent) {
        function Page() {
            return (0, _classCallCheck3.default)(this, Page), (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, 
            _getPrototypeOf2.default)(Page)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Page, _PureComponent), (0, _createClass3.default)(Page, [ {
            key: "render",
            value: function() {
                return _react2.default.createElement(_styledComponents.ThemeProvider, {
                    theme: {}
                }, _react2.default.createElement(Wrapper, null, _react2.default.createElement(BannerContainer, {
                    "aria-hidden": this.props.isBannerOpen,
                    isBannerOpen: this.props.isBannerOpen
                }, _react2.default.createElement(Banner, null, this.props.banner)), _react2.default.createElement(NavigationAndContent, null, _react2.default.createElement(Navigation, null, this.props.navigation), _react2.default.createElement(PageContent, {
                    navigationWidth: this.props.navigationWidth
                }, this.props.children))));
            }
        } ]), Page;
    }(_react.PureComponent);
    Page.displayName = "AkPage", Page.propTypes = {
        banner: _react.PropTypes.node,
        children: _react.PropTypes.node,
        isBannerOpen: _react.PropTypes.bool,
        navigation: _react.PropTypes.node,
        navigationWidth: _react.PropTypes.number
    }, Page.defaultProps = {
        isBannerOpen: !1,
        navigationWidth: 0
    }, exports.default = Page;
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/@atlaskit/page/dist/bundle-cjs.js
// module id = 300
// module chunks = 0